import {
  LOCAL
} from '../constants/funcUrl'

/**
 * 本地
 */
const localAction = {
  // 企业报名学员
  addEnrollStudent: ({
    commit
  }, params) => {
    return commit(LOCAL.ENROLLSTUDENT, params);
  },
  // 企业报名学员
  addEnroll: ({
    commit
  }, params) => {
    return commit(LOCAL.ENROLL, params);
  }
}

export default localAction;



// WEBPACK FOOTER //
// ./src/store/jzjy/actions/localAction.js